<template>
    <div>
        <div class="d-flex align-center justify-center">
            <v-timeline :class="!verMais ? 'mb-16' : 'mb-6'">
                <v-timeline-item
                    v-for="item in reavaliacoes"
                    :key="item.id"
                    :color="ehReavaliacaoEmElaboracao(item) ? '#f9a825': 'primary'"
                    :icon="ehReavaliacaoEmElaboracao(item) ? 'priority_high' : 'done'"
                    fill-dot small>
                    <template v-slot:opposite>
                        <span class="text-left text--darken-1 grey--text text-body-2">{{item.dataFinalizacao | azDate('DD/MM/YYYY')}}</span>
                    </template>
                    <v-card width="700"
                            v-if="ehReavaliacaoEmElaboracao(item)"
                            @click="formatarReavaliacao(item)">
                        <v-card-title
                            class="font-weight-bold text-body-1 pb-0 text--darken-3">
                            Reavaliação
                        </v-card-title>
                        <v-card-text class="text-left text--darken-1 grey--text">
                            <span class="font-weight-bold">De: </span>{{item.valorLiquido | valorParaDinheiro }}<br/>
                            <span class="font-weight-bold">Para: </span>{{item.valorReavaliado | valorParaDinheiro}}<br/>
                            <span class="font-weight-bold">Situação: </span>{{item.situacao | azEnum(situacoesReavaliacao)}}
                        </v-card-text>
                    </v-card>
                    <v-card color="mx-auto" width="700" v-else>
                        <v-card-title
                            class="font-weight-bold text-body-1 pb-0 text--darken-1 primary--text">
                            Reavaliação
                        </v-card-title>
                        <v-card-text class="text-left text--darken-1 grey--text">
                            <span class="font-weight-bold">De: </span>{{item.valorLiquido | valorParaDinheiro }}<br/>
                            <span class="font-weight-bold">Para: </span>{{item.valorReavaliado | valorParaDinheiro }}<br/>
                            <span class="font-weight-bold">Situação: </span>{{item.situacao | azEnum(situacoesReavaliacao)}}
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions class="pa-0 px-3">
                            <v-flex>
                                <v-row>
                                    <v-btn color="primary" text width="49%" class="text-body-4" @click="abrirModalMaisDetalhes(item)">
                                        Mais Detalhes
                                    </v-btn>
                                    <v-divider vertical></v-divider>
                                    <v-btn color="primary" text width="49%" class="text-body-4" @click="acessarVisualizacao(item)">
                                        Acessar
                                        <v-icon class="ml-2" size="14">fas fa-external-link-alt</v-icon>
                                    </v-btn>
                                </v-row>
                            </v-flex>
                        </v-card-actions>
                    </v-card>
                </v-timeline-item>
            </v-timeline>
        </div>
        <div class="d-flex align-center justify-center pb-16" v-if="verMais">
            <v-btn color="primary" class="call-to-action text-body-2" @click="verMaisLinhaDoTempo">
                Ver Mais
            </v-btn>
        </div>
    </div>
</template>

<script>
    import {situacoesReavaliacao} from '@/core/constants'

    export default {
        name: 'LinhaDoTempoReavaliacao',
        props: ['items', 'orgaos'],
        data() {
            return {
                reavaliacoes: [],
                verMais: false,
                reavaliacaoSelecionada: {}
            }
        },
        computed: {
            situacoesReavaliacao() {
                return situacoesReavaliacao
            },
            reavaliacoesMaiorQueCinco() {
                return this.items.length > 5
            }
        },
        watch: {
            'items'() {
                this.formatarLinhaDoTempo()
            }
        },
        mounted() {
            this.$gtag.event('MovimentacoesLinhaTempo', { method: 'Google' })
            this.formatarLinhaDoTempo()
        },
        methods: {
            ehReavaliacaoEmElaboracao(reavaliacao) {
                return reavaliacao.situacao === 'EM_ELABORACAO'
            },
            verMaisLinhaDoTempo() {
                this.reavaliacoes = this.items
                this.verMais = false
            },
            formatarReavaliacao(item) {
                this.reavaliacaoSelecionada = {
                    id: item.id,
                    orgaoDestino: item.orgaoDestino ? item.orgaoDestino : null,
                    orgaoOrigem: item.orgaoOrigem.id,
                    idPatrimonio: this.$route.params.id,
                    motivo: item.motivo,
                    tipo: item.tipo,
                    situacao: item.situacao
                }
            },
            async formatarLinhaDoTempo() {
                this.verMais = false
                this.reavaliacoes = this.items
                if (this.reavaliacoesMaiorQueCinco) {
                    this.reavaliacoes = this.items.slice(0, 5)
                    this.verMais = true
                }
            },
            abrirModalMaisDetalhes(item) {
                this.$emit('abrirModalMaisDetalhes', item)
            },
            acessarVisualizacao(item) {
                this.$emit('acessarVisualizacao', item)
            }
        }
    }
</script>


<style lang="stylus">
    .max-10
        max-width 10vw

    .iconeCard
        border-radius 50%
        height 40px
        width 40px
        background-color: #D9D9D9

</style>
